export const AREAS = [
  "Small Business",
  "Retirement Planning & Pensions",
  "Small Business Financial Management",
  "Personal Budgeting & Debt Management",
  "Insurance & Risk Management",
];
 
export const SUBCATEGORIES = {
  "Small Business": [
    "Government Regulation",
    "Achieve borrowing",
    "Risk Assessment",
    "Investment Strategies",
    "Market Analysis",
    "Securities Trading",
    "Mutual Funds",
    "ETFs",
    "Bonds",
    "Stocks",
  ],
  "Retirement Planning & Pensions": [
    "Government Regulation",
    "IRA Management",
    "Pension Plans",
    "Social Security",
    "Estate Planning",
    "Retirement Income",
    "Healthcare Costs",
    "Long-term Care",
  ],
  "Small Business Financial Management": [
    "Cash Flow Management",
    "Financial Statements",
    "Business Funding",
    "Financial Policies And Procedures",
    "Financial Reports And Statements",
    "Regulatory Documents",
    "Banking Agreements",
    "Compliance Fintech",
    "Business Banking",
    "Invoice Management",
    "Cost Management",
    "Secured Lending",
  ],
  "Personal Budgeting & Debt Management": [
    "Budget Planning",
    "Expense Tracking",
    "Debt Consolidation",
    "Credit Score",
    "Emergency Fund",
    "Savings Goals",
    "Monthly Planning",
    "Financial Discipline",
    "Secured Lending",
  ],
  "Insurance & Risk Management": [
    "Life Insurance",
    "Health Insurance",
    "Property Insurance",
    "Liability Coverage",
    "Liability Insurance",
    "Risk Assessment",
    "Premium Calculation",
    "Claims Process",
    "Insurance Planning",
  ],
};
 
export const QUESTION_TYPES = [
  { label: "Multiple Choice Question", key: "mcq" },
  { label: "Fill In The Blank", key: "fill" },
  { label: "True & False", key: "tf" },
  // { label: "Generate Summary", key: "summary" },
];
 
export const QUESTION_TYPES_RIGHT = [
  { label: "Interpretive Question", key: "interpritive" },
  { label: "Descriptive Question", key: "descriptive" },
  { label: "Short Question", key: "short" },
  { label: "Scenario Question", key: "scenario" },
];
 
export function calculateApiCalls (wordCount, chunkSize = 3000, tolerance = 299) {
    try{
 
      const remainder = wordCount % chunkSize;
    if (remainder === 0) {
        const apiCalls = Math.floor(wordCount / chunkSize);
        return apiCalls;
    } else if (remainder <= tolerance) {
        const apiCalls = Math.floor(wordCount / chunkSize);
        return apiCalls;
    } else {
        const apiCalls = Math.ceil(wordCount / chunkSize);
        return apiCalls;
    }
    }catch(err){
      console.log('Error while calculating API calls :', err);
      
    }
}   
 
const QUESTION_LIMITS = [
  { min: 300,  max: 500,  total: 7 },
  { min: 501,  max: 1000, total: 10 },
  { min: 1001, max: 1500, total: 14 },
  { min: 1501, max: 2000, total: 17 },
  { min: 2001, max: 2500, total: 24 },
  { min: 2501, max: 3299, total: 30 },
];

function slabTotalFor(words) {
  for (let row of QUESTION_LIMITS) {
    if (words >= row.min && words <= row.max) return row.total;
  }
  if (words >= 3000) return QUESTION_LIMITS[QUESTION_LIMITS.length - 1].total;
  return 0;
}

export function getQuestionLimit(wordCount) {
  const wc = Number(wordCount) || 0;
  if (wc < 300) return 0;

  const version = (localStorage.getItem('Version') || '').toLowerCase();
  const storedLimit = Number(localStorage.getItem("QuestionLimitNo") || 0);
  const perCycleCap = version === 'free' ? 10 : (storedLimit > 0 ? storedLimit : 30);

  const CYCLE_LENGTH = 3000;
  const completeCycles = Math.floor(wc / CYCLE_LENGTH);
  const remainingWords = wc % CYCLE_LENGTH;

  const perFullCycleQuestions = Math.min(slabTotalFor(3000), perCycleCap);

  let totalQuestions = completeCycles * perFullCycleQuestions;

  if (remainingWords >= 300) {
    const remainingSlab = Math.min(slabTotalFor(remainingWords), perCycleCap);
    totalQuestions += remainingSlab;
  }

  return totalQuestions;
}

/**
 * getRequiredSets(wordCount)
 * Returns how many user "sets" are required given the per-cycle/per-set cap stored in localStorage.
 * - Uses QuestionLimitNo (10 or 30) as the per-set capacity for tiered users.
 * - For 'Free' version per-set capacity is always 10.
 */
export function getRequiredSets(wordCount) {
  const totalQuestions = getQuestionLimit(wordCount);
  const version = (localStorage.getItem('Version') || '').toLowerCase();
  const storedLimit = Number(localStorage.getItem("QuestionLimitNo") || 0);
  const perSet = version === 'free' ? 10 : (storedLimit > 0 ? storedLimit : 30);
  if (perSet <= 0) return 0;
  return Math.ceil(totalQuestions / perSet) || 0;
}

export default QUESTION_LIMITS;